"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmptyView;
var _react = _interopRequireDefault(require("react"));
var _StyledPlaceholderView = require("../styled/StyledPlaceholderView");
var _ykbStyledComponents = require("../../ykb-styled-components");
function DocumentIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "40",
    viewBox: "0 0 32 40"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group_10413",
    "data-name": "Group 10413",
    transform: "translate(-1654.5 -407.806)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_4258",
    "data-name": "Path 4258",
    d: "M1686.422,416.421a.987.987,0,0,0-.216-.323l-8-8a1.018,1.018,0,0,0-.323-.216,1.006,1.006,0,0,0-.385-.077h-22a1,1,0,0,0-1,1v38a1,1,0,0,0,1,1h30a1,1,0,0,0,1-1v-30A.988.988,0,0,0,1686.422,416.421Zm-7.922-5.2,4.586,4.586H1678.5Zm-22,34.586v-36h20v7a1,1,0,0,0,1,1h7v28Z",
    fill: "#abafc1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_4259",
    "data-name": "Path 4259",
    d: "M1677.5,422.806h-14a1,1,0,0,0,0,2h14a1,1,0,0,0,0-2Z",
    transform: "translate(0 1)",
    fill: "#abafc1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_4260",
    "data-name": "Path 4260",
    d: "M1677.5,429.806h-14a1,1,0,0,0,0,2h14a1,1,0,0,0,0-2Z",
    fill: "#abafc1"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M1671.5,436.806h-8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z",
    transform: "translate(0 -1)",
    fill: "#abafc1"
  })));
}
function EmptyView(_ref) {
  var text = _ref.text,
    children = _ref.children,
    minHeight = _ref.minHeight;
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledPlaceholderView.StyledPlaceholderView, {
      theme: theme,
      $minHeight: minHeight
    }, /*#__PURE__*/_react.default.createElement(_StyledPlaceholderView.StyledIconContainer, null, /*#__PURE__*/_react.default.createElement(DocumentIcon, null)), /*#__PURE__*/_react.default.createElement(_StyledPlaceholderView.StyledPlaceholderText, null, text ? text : '', children));
  });
}